/**
 * Téléchargement de fichiers générés côté renderer (lien temporaire + Blob).
 * Mutualisé pour éviter de répéter la mécanique `createObjectURL` / `<a download>`
 * dans chaque contrôleur de vue.
 */

/** Déclenche le téléchargement d'un blob sous le nom de fichier indiqué. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Télécharge un contenu CSV, préfixé du BOM UTF-8 attendu par Excel. */
export function downloadCsv(content: string, filename: string): void {
  downloadBlob(new Blob(['\uFEFF' + content], { type: 'text/csv;charset=utf-8;' }), filename);
}

/** Télécharge un classeur Excel (.xlsx). */
export function downloadExcel(buffer: ArrayBuffer, filename: string): void {
  downloadBlob(
    new Blob([new Uint8Array(buffer)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    filename,
  );
}
